import { sentenceCase } from '~/utils/string'

const BBHomepage = {
  name: 'Broadband',
  link: 'https://www.uswitch.com/broadband/'
}

const TVHomepage = {
  name: 'TV',
  link: 'https://www.uswitch.com/tv/'
}

const ChannelHomepage = (scope, formattedScope) => ({
  name: `${sentenceCase(formattedScope)}`,
  link: `https://www.uswitch.com/${scope}/`
})

export const broadbandCrumbs = (pageTitle) => [
  BBHomepage,
  {
    name: pageTitle
  }
]

export const tvCrumbs = [
  {
    name: 'TV',
    link: 'https://www.uswitch.com/tv/'
  },
  {
    name: 'Compare TV deals',
    link: 'https://www.uswitch.com/tv/compare/'
  },
  {
    name: 'TV Packages'
  }
]

export const tvProvidersCrumbs = (pageTitle) =>
  [TVHomepage].concat(
    pageTitle
      ? [
          {
            name: 'TV providers',
            link: 'https://www.uswitch.com/tv/providers/'
          },
          {
            name: pageTitle
          }
        ]
      : [{ name: 'TV providers' }]
  )

export const providersCrumbs = (pageTitle, scope = 'broadband', formattedScope = 'broadband') =>
  [ChannelHomepage(scope, formattedScope)].concat(
    pageTitle
      ? [
          {
            name: `${sentenceCase(formattedScope)} providers`,
            link: `https://www.uswitch.com/${scope}/providers/`
          },
          {
            name: pageTitle
          }
        ]
      : [{ name: `${sentenceCase(formattedScope)} providers` }]
  )

export const localCrumbs = (location) =>
  [BBHomepage].concat(
    !location
      ? [
          {
            name: 'Broadband local',
            link: 'https://www.uswitch.com/broadband/local'
          }
        ]
      : [
          {
            name: 'Broadband local',
            link: 'https://www.uswitch.com/broadband/local'
          },
          {
            name: `${sentenceCase(location)}`
          }
        ]
  )
